export const text = {
    "heading": {
        "xSmall": "var(--textHeadingXSmall)",
        "small": "var(--textHeadingSmall)",
        "medium": "var(--textHeadingMedium)",
        "large": "var(--textHeadingLarge)",
        "xLarge": "var(--textHeadingXLarge)"
    },
    "body": {
        "regular": {
            "xSmall": "var(--textBodyRegularXSmall)",
            "small": "var(--textBodyRegularSmall)",
            "medium": "var(--textBodyRegularMedium)",
            "large": "var(--textBodyRegularLarge)"
        },
        "bold": {
            "xSmall": "var(--textBodyBoldXSmall)",
            "small": "var(--textBodyBoldSmall)",
            "medium": "var(--textBodyBoldMedium)",
            "large": "var(--textBodyBoldLarge)"
        }
    },
    "code": {
        "regular": {
            "xSmall": "var(--textCodeRegularXSmall)",
            "small": "var(--textCodeRegularSmall)",
            "medium": "var(--textCodeRegularMedium)",
            "large": "var(--textCodeRegularLarge)"
        },
        "bold": {
            "xSmall": "var(--textCodeBoldXSmall)",
            "small": "var(--textCodeBoldSmall)",
            "medium": "var(--textCodeBoldMedium)",
            "large": "var(--textCodeBoldLarge)"
        }
    }
} as const;
export const fontFamily = {
    "default": "var(--fontFamilyDefault)",
    "code": "var(--fontFamilyCode)"
} as const;
